"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const helpers_1 = require("../../../../common/helpers/helpers");
const useUrlParams_1 = require("../../../hooks/useUrlParams");
const BookingStatus_1 = __importDefault(require("../../Other/BookingStatus"));
const WeatherSlide_1 = __importDefault(require("./WeatherSlide"));
const HandoverSlide_1 = __importDefault(require("./HandoverSlide"));
const useAvailabilities_1 = __importDefault(require("../../../hooks/useAvailabilities"));
const useOrientation_1 = require("../../../hooks/useOrientation");
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const SlideContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: ${(props) => props.src !== ''
    ? `linear-gradient(90deg, #000000 -29.92%, rgba(0, 0, 0, 0.08) 64.72%), url(${props.src})`
    : `linear-gradient(135deg, ${props.theme.palette.mainAppColor.main} 0%, ${props.theme.palette.mainAppColor.contrastText} 50%, ${props.theme.palette.mainAppColor.main} 100%)`};
  background-size: cover;
  background-position: center;
  padding: 10vmin;

  @media (orientation: portrait) {
    justify-content: flex-end;
    background-image: ${(props) => props.src !== ''
    ? `linear-gradient(0deg, #000000 -29.92%, rgba(0, 0, 0, 0.08) 64.72%), url(${props.src})`
    : `linear-gradient(135deg, ${props.theme.palette.mainAppColor.main} 0%, ${props.theme.palette.mainAppColor.contrastText} 50%, ${props.theme.palette.mainAppColor.main} 100%)`};
  }
`;
const MainInfoWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: 50vmin;
  height: 100%;
  width: 100%;
  color: white;
  gap: 3vmin;
  line-height: initial;
`;
const MainInfoContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1.5vmin;
  flex: 1;
  min-width: 0;
`;
const TextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 3vmin;
`;
const QrCodeContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08), 0 0 0 2px rgba(0, 0, 0, 0.08);
  padding: 1.5vmin;
  border-radius: 8px;
  gap: 1vmin;
  position: absolute;
  right: 5vmin;
  bottom: 2vmin;

  .qr-code {
    display: block;
    width: clamp(120px, 16vmin, 360px) !important;
    height: clamp(120px, 16vmin, 360px) !important;
    padding: 1vmin;
    background-color: white;
    border-radius: 8px;
  }
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  gap: 20px;
  margin-top: 20px;

  button {
    border-radius: 71px;
    padding: 1.2vmin 4vmin;
  }
`;
const Title = styled_components_1.default.p `
  font-size: 5vmin;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  font-weight: bold;
`;
const Text = styled_components_1.default.p `
  font-size: 3.5vmin;
  margin: 0;
`;
const ButtonText = styled_components_1.default.p `
  font-size: 2.5vmin;
  text-transform: initial;
  margin: 0;
`;
const Slide = ({ content, currentLocale, timezone, updateStore }) => {
    var _a, _b;
    const { brand, venue: urlVenue } = (0, useUrlParams_1.useUrlParams)();
    const availabilityFromHook = (0, useAvailabilities_1.default)(content, brand, urlVenue);
    const availabilityState = (_b = (_a = content === null || content === void 0 ? void 0 : content.availability) === null || _a === void 0 ? void 0 : _a.availabilityState) !== null && _b !== void 0 ? _b : availabilityFromHook;
    const orientation = (0, useOrientation_1.useOrientation)();
    const locale = content.locale ? content.locale : currentLocale;
    const renderContentDateAndTime = () => {
        const { date: datePart, time: timePart } = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, locale, timezone, true);
        const endTime = helpers_1.Helpers.getHourFromDate(content.end, timezone, locale);
        const isGermanLocale = locale === null || locale === void 0 ? void 0 : locale.toLowerCase().startsWith('de');
        const endTimeWithSuffix = isGermanLocale ? `${endTime} Uhr` : endTime;
        const timePartWithSuffix = isGermanLocale ? `${timePart} Uhr` : timePart;
        if (content.showStartTime && content.showEndTime) {
            return `${datePart} • ${timePart} - ${endTimeWithSuffix}`;
        }
        if (!content.showStartTime && content.showEndTime) {
            return `${datePart} • ${i18n_js_1.default.t('dictionary.until', { locale })} ${endTimeWithSuffix}`;
        }
        if (content.showStartTime && !content.showEndTime) {
            return `${datePart} • ${i18n_js_1.default.t('dictionary.from', { locale })} ${timePartWithSuffix}`;
        }
        return datePart;
    };
    const handleOpenDialog = (content) => {
        updateStore('isDialogOpen', true);
        updateStore('dialogContent', content);
        updateStore('isCarouselPaused', true);
    };
    const isFullScreen = content.dsFullScreen;
    const isPortraitMode = orientation === 'portrait';
    const imageRatio = isPortraitMode ? '10:10' : '2:1';
    const imageSize = isPortraitMode ? 'XXL' : 'XXL';
    const imgUrl = content &&
        content.images &&
        content.images[0] &&
        content.images[0][imageRatio] &&
        content.images[0][imageRatio][imageSize]
        ? content.images[0][imageRatio][imageSize]
        : null;
    const iconUrl = content && content.icon && content.icon[imageRatio] && content.icon[imageRatio][imageSize]
        ? content.icon[imageRatio][imageSize]
        : null;
    if (content.type === 'weather') {
        return react_1.default.createElement(WeatherSlide_1.default, { isDsInteractive: true, data: content });
    }
    if (content.type === 'handover') {
        return react_1.default.createElement(HandoverSlide_1.default, null);
    }
    const isBookable = content.bookable &&
        (availabilityState === 'available' ||
            availabilityState === 'few_places_left' ||
            availabilityState === 'user_has_active_booking');
    return (react_1.default.createElement(SlideContainer, { src: imgUrl || iconUrl },
        !isFullScreen && (react_1.default.createElement(MainInfoWrapper, null,
            react_1.default.createElement(MainInfoContent, null,
                react_1.default.createElement(TextContainer, null,
                    react_1.default.createElement(Title, null, content.title),
                    content.type === 'activity' && react_1.default.createElement(Text, null, renderContentDateAndTime()),
                    content.placeName && react_1.default.createElement(Text, null, content.placeName)),
                availabilityState && (react_1.default.createElement(BookingStatus_1.default, { availabilityState: availabilityState, size: 0.95, currentLocale: locale })),
                react_1.default.createElement(ButtonsContainer, null,
                    react_1.default.createElement(material_1.Button, { color: "mainAppColor", variant: "contained", onClick: () => handleOpenDialog(content) },
                        react_1.default.createElement(ButtonText, null, i18n_js_1.default.t('see_details'))))))),
        !isFullScreen && content.deeplink && isBookable && (react_1.default.createElement(QrCodeContainer, null,
            react_1.default.createElement(qrcode_react_1.default, { value: content.deeplink, size: 320, className: "qr-code" }),
            react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { color: 'white' } }, i18n_js_1.default.t('dictionary.handover.booking_message', { locale }))))));
};
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Slide);
